import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Printer = createSvgIcon(
  () => (
    <path
      d="M28.9 9.6V3H11.1V9.6H8.1V0H31.9V9.6H28.9ZM3 12.6H37H8.1H3ZM32.95 17.35C33.35 17.35 33.7 17.2 34 16.9C34.3 16.6 34.45 16.25 34.45 15.85C34.45 15.45 34.3 15.1 34 14.8C33.7 14.5 33.35 14.35 32.95 14.35C32.55 14.35 32.2 14.5 31.9 14.8C31.6 15.1 31.45 15.45 31.45 15.85C31.45 16.25 31.6 16.6 31.9 16.9C32.2 17.2 32.55 17.35 32.95 17.35ZM28.9 33V23.4H11.1V33H28.9ZM31.9 36H8.1V27.2H0V14.9C0 13.4 0.508333 12.1417 1.525 11.125C2.54167 10.1083 3.8 9.6 5.3 9.6H34.7C36.2 9.6 37.4583 10.1083 38.475 11.125C39.4917 12.1417 40 13.4 40 14.9V27.2H31.9V36ZM37 24.2V14.9C37 14.2333 36.7833 13.6833 36.35 13.25C35.9167 12.8167 35.3667 12.6 34.7 12.6H5.3C4.63333 12.6 4.08333 12.8167 3.65 13.25C3.21667 13.6833 3 14.2333 3 14.9V24.2H8.1V20.4H31.9V24.2H37Z"
      fill="#2A3234"
    />
  ),
  '0 0 40 36',
  'Printer'
);
